import { keyframes } from '@mui/system';

import {
  buttonIcon,
  buttonPrimary,
  colors,
  fonts,
  input,
  thinScrollbar,
} from '../../theme';

// The panel comes from the right, like a drawer.
const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(48px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

const styles = {
  panel: {
    width: 380,
    flexShrink: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: '14px',
    overflow: 'hidden',
    animation: `${slideIn} 280ms cubic-bezier(0.22, 1, 0.36, 1) both`,
  },
  embedded: {
    flexGrow: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    height: 52,
    flexShrink: 0,
    pl: 2,
    pr: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.border}`,
  },
  title: {
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
  },
  close: buttonIcon,
  list: {
    ...thinScrollbar,
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    py: 0.5,
  },
  empty: {
    py: 6,
    px: 3,
    textAlign: 'center',
    fontFamily: fonts.text,
    fontSize: 13,
    color: colors.textSubtle,
  },
  toggleReplies: {
    ml: 7,
    mb: 1,
    p: 0,
    border: 0,
    backgroundColor: 'transparent',
    fontFamily: fonts.text,
    fontSize: 12,
    fontWeight: 600,
    color: colors.textSecondary,
    cursor: 'pointer',
    '&:hover': {
      color: colors.text,
    },
  },
  loading: {
    py: 2,
    display: 'flex',
    justifyContent: 'center',
  },
  spinner: {
    color: colors.text,
  },
  replyBar: {
    flexShrink: 0,
    px: 2,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    fontFamily: fonts.text,
    fontSize: 12,
    color: colors.textSecondary,
  },
  cancelReply: {
    p: 0,
    border: 0,
    backgroundColor: 'transparent',
    fontFamily: fonts.text,
    fontSize: 12,
    fontWeight: 600,
    color: colors.text,
    cursor: 'pointer',
  },
  // No line above the field, like TikTok: the list and the field are one block.
  form: {
    // The mention suggestions are positioned above the field.
    position: 'relative',
    flexShrink: 0,
    display: 'flex',
    gap: 1,
    px: 2,
    py: 1.5,
  },
  input: {
    ...input,
    flexGrow: 1,
  },
  send: buttonPrimary,
  guestForm: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.25,
    px: 2,
    py: 1.5,
    fontFamily: fonts.text,
    fontSize: 13,
    color: colors.textSecondary,
  },
};

export default styles;
